<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="methodPayment.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <UploadImage
            @changePicture="(value) => (methodPayment.picture = value)"
            :title="'Imagem'"
            :proportion="'Proporção: 20x20'"
          />
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import UploadImage from "@/components/upload/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Novo método de pagamento",
          routerName: "RegisterMethodPayment",
        },
      ],
      methodPayment: {
        id_user: "",
        name: "",
        picture: null,
      },
      methodPaymentParams: this.$route.params,
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      methodPaymentData: "Professional/methodPayment",
    }),
    hasMethodPaymentParams() {
      return (
        this.methodPaymentParams &&
        Object.keys(this.methodPaymentParams).length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    UploadImage,
  },
  methods: {
    ...mapActions(["setImageFileUrl"]),
    ...mapActions("Professional", [
      "registerMethodPayment",
      "consultMethodPayment",
    ]),
    async handleSubmit() {
      const message = this.methodPayment?.id
        ? "Método de pagamento editado com sucesso!"
        : "Método de pagamento cadastrado com sucesso!";

      this.methodPayment.id_user = this.user.id;

      await this.registerMethodPayment(this.methodPayment);
      this.$router.push({ name: "ListMethodPayment" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
    handleBreadcrumbEdit() {
      this.links[1] = {
        name: "Listar Métodos de Pagamento",
        routerName: "ListMethodPayment",
      };
      this.links.push({
        name: this.methodPayment.name,
        routerName: "RegisterMethodPayment",
      });
    },
  },
  async mounted() {
    this.setImageFileUrl(null);
    if (this.hasMethodPaymentParams) {
      await this.consultMethodPayment(this.methodPaymentParams.id);
      this.methodPayment = this.methodPaymentData;
      this.handleBreadcrumbEdit();
      this.setImageFileUrl(this.methodPayment.picture);
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
